import { jordanDate } from '@serb/shared';
import { useApprovals } from '../approvals/useApprovals';
import { useReminders } from '../reminders/useReminders';
import { isActive, needsAttention } from '../shipments/sample';
import { useShipments } from '../shipments/useShipments';

export type Summary = { approvals: number; urgent: number; shipments: number; reminders: number };

/** The counts on the Home tiles, the menu badge and the bell, counted from the real approvals, shipments and reminders */
export function useSummary(): Summary {
  const pending = useApprovals().items.filter((a) => a.status === 'pending');
  const { items: ships } = useShipments();
  const { items: reminders } = useReminders();
  const today = jordanDate();
  const urgentShips = ships.filter((s) => isActive(s) && needsAttention(s)).length;
  return {
    approvals: pending.length,
    urgent: pending.filter((a) => a.urgency === 'High').length + urgentShips,
    shipments: ships.filter(isActive).length,
    reminders: reminders.filter((r) => !r.complete && r.date === today).length,
  };
}
